import React from 'react';
import { cn } from './_cn';
import FieldLabel from './field-label';

const sizes = {
  sm: 'h-9 text-sm',
  md: 'h-10 text-sm',
  lg: 'h-11 text-base',
};

const TWInput = React.forwardRef(
  (
    {
      label,
      labelIcon,
      error,
      hint,
      leftIcon: LeftIcon,
      rightIcon: RightIcon,
      size = 'md',
      id,
      required,
      className = '',
      wrapperClassName = '',
      ...rest
    },
    ref,
  ) => {
    const generatedId = React.useId();
    const inputId = id || generatedId;
    const hasError = Boolean(error);
    return (
      <div className={cn('w-full', wrapperClassName)}>
        {label ? (
          <FieldLabel htmlFor={inputId} icon={labelIcon} required={required}>
            {label}
          </FieldLabel>
        ) : null}
        <div className="relative">
          {LeftIcon ? (
            <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
              <LeftIcon className="h-4 w-4" aria-hidden />
            </span>
          ) : null}
          <input
            ref={ref}
            id={inputId}
            aria-invalid={hasError || undefined}
            className={cn(
              'block w-full rounded-md border bg-white text-slate-900 placeholder-slate-400 transition',
              'focus:outline-none focus:ring-1',
              'disabled:cursor-not-allowed disabled:opacity-60',
              'dark:bg-slate-900 dark:text-slate-100 dark:placeholder-slate-500',
              hasError
                ? 'border-rose-400 focus:border-rose-500 focus:ring-rose-500 dark:border-rose-500/70'
                : 'border-slate-300 focus:border-blue-500 focus:ring-blue-500 dark:border-slate-600 dark:focus:border-sky-400 dark:focus:ring-sky-400',
              sizes[size] || sizes.md,
              LeftIcon ? 'pl-9' : 'pl-3',
              RightIcon ? 'pr-9' : 'pr-3',
              className,
            )}
            {...rest}
          />
          {RightIcon ? (
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400">
              <RightIcon className="h-4 w-4" aria-hidden />
            </span>
          ) : null}
        </div>
        {error || hint ? (
          <p
            className={cn(
              'mt-1 text-xs',
              hasError
                ? 'text-rose-600 dark:text-rose-400'
                : 'text-slate-500 dark:text-slate-400',
            )}
          >
            {error || hint}
          </p>
        ) : null}
      </div>
    );
  },
);

TWInput.displayName = 'TWInput';

export default TWInput;
